import PickersSection from "./pickers-section/PickersSection";
import Timezones, { TimezonesProps } from "./timezones/Timezones";
import styled from "@emotion/styled";

interface ScheduleProps extends TimezonesProps {
    /**
     * Optional field name prefix for form field namespacing
     */
    fieldPrefix?: string;

    /**
     * if true, inputs are disabled
     */
    disabled?: boolean;

    /**
     * if true, skips the 24-hour max duration validation
     * @default false
     */
    skipMaxDurationValidation?: boolean;

    /**
     * ID of the element that describes this section for accessibility
     */
    "aria-describedby"?: string;
}

export const StyledScheduleWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
}));

/**
 * SessionTime component - contains date and time pickers along with timezone selection
 */
export const Schedule = (props: ScheduleProps) => {
    const {
        timezones,
        fieldPrefix,
        disabled = false,
        skipMaxDurationValidation = false,
        "aria-describedby": ariaDescribedBy,
    } = props;

    return (
        <StyledScheduleWrapper>
            <PickersSection
                fieldPrefix={fieldPrefix}
                disabled={disabled}
                skipMaxDurationValidation={skipMaxDurationValidation}
                aria-describedby={ariaDescribedBy}
            />
            <Timezones
                timezones={timezones}
                fieldPrefix={fieldPrefix}
                disabled={disabled}
                aria-describedby={ariaDescribedBy}
            />
        </StyledScheduleWrapper>
    );
};
